export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10693.13a66be1.jpg";